import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const CiFormPage = lazy(() => import('./ci-form-page').then((m) => ({ default: m.CiFormPage })));
const CmdbPage = lazy(() => import('./cmdb-page').then((m) => ({ default: m.CmdbPage })));

export const cmdbRoutes: RouteObject[] = [
  {
    path: 'cmdb',
    handle: { crumb: 'CMDB' },
    children: [
      { index: true, element: <CmdbPage /> },
      { path: 'new', element: <CiFormPage />, handle: { crumb: 'New CI' } },
      { path: ':id', element: <CmdbPage />, handle: { crumb: (p: Record<string, string | undefined>) => p.id ?? 'CI' } },
      { path: ':id/edit', element: <CiFormPage />, handle: { crumb: 'Edit' } },
    ],
  },
];
